"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceTree = void 0;
const token_utils_1 = require("@saberhq/token-utils");
const js_sha3_1 = require("js-sha3");
const merkle_tree_1 = require("./merkle-tree");
class BalanceTree {
    constructor(balances) {
        this.tree = new merkle_tree_1.MerkleTree(balances.map(({ account, amount }, index) => {
            return BalanceTree.toNode(index, account, amount);
        }));
    }
    static verifyProof(index, account, amount, proof, root) {
        let pair = BalanceTree.toNode(index, account, amount);
        for (const item of proof) {
            pair = merkle_tree_1.MerkleTree.combinedHash(pair, item);
        }
        return pair.equals(root);
    }
    // keccak256(abi.encode(index, account, amount))
    static toNode(index, account, amount) {
        const buf = Buffer.concat([
            new token_utils_1.u64(index).toArrayLike(Buffer, "le", 8),
            account,
            new token_utils_1.u64(amount).toArrayLike(Buffer, "le", 8),
        ]);
        return Buffer.from((0, js_sha3_1.keccak_256)(buf), "hex");
    }
    getHexRoot() {
        return this.tree.getHexRoot();
    }
    // returns the hex bytes32 values of the proof
    getHexProof(index, account, amount) {
        return this.tree.getHexProof(BalanceTree.toNode(index, account, amount));
    }
    getRoot() {
        return this.tree.getRoot();
    }
    getProof(index, account, amount) {
        return this.tree.getProof(BalanceTree.toNode(index, account, amount));
    }
}
exports.BalanceTree = BalanceTree;
//# sourceMappingURL=balance-tree.js.map